import axios from "../../lib/axiosInstance";

export function updateTask(payload) {
  return axios.patch(`tasks/${payload.id}`, payload).then((res) => res.data);
}
